import { AutoComplete, FormInput, SwitchInput } from "@4uhub/lib4uhub";
import { Divider, Grid, Typography } from "@mui/material";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { companyDigitalCertificateList } from "../../../../../../../services/companyDigitalCertificate.service";

interface ICertillionProps {
  namePrefix: string;
}

const translationPath = "page.4uBus.register.iService.certillion.";
const sharedTranslationPath = "page.4uBus.register.iService.";

export const Certillion = memo(({ namePrefix }: ICertillionProps) => {
  const { t } = useTranslation();

  const getName = (fieldName: string) => `${namePrefix}.${fieldName}`;

  return (
    <>
      <Grid item xs={12} md={6}>
        <SwitchInput
          name={getName("isCertillionCloud")}
          label={t(translationPath + "is_certillion_cloud")}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <SwitchInput
          name={getName("authorizeLocal")}
          label={t(translationPath + "authorize_local")}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <FormInput
          size="small"
          name={getName("baseUrl")}
          label={t(translationPath + "base_url")}
          fullWidth
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <FormInput
          size="small"
          name={getName("baseUrlProxy")}
          label={t(translationPath + "base_url_proxy")}
          fullWidth
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <FormInput
          size="small"
          name={getName("clientId")}
          label={t(translationPath + "client_id")}
          fullWidth
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <FormInput
          size="small"
          name={getName("clientSecret")}
          label={t(translationPath + "client_secret")}
          type="password"
          fullWidth
        />
      </Grid>

      <Grid item xs={12}>
        <AutoComplete
          size="small"
          name={getName("companyDigitalCertificate")}
          request={companyDigitalCertificateList}
          label={t(sharedTranslationPath + "digital_certificate")}
          getOptionLabel={(option) => option.name}
          fullWidth
        />
      </Grid>

      <Grid item xs={12}>
        <FormInput
          size="small"
          name={getName("signatureStandardOptions")}
          label={t(translationPath + "signature_standard_options")}
          fullWidth
          multiline
          rows={4}
        />
      </Grid>

      <Grid item xs={12} sx={{ mt: 1 }}>
        <Divider sx={{ mb: 1.5 }} />
        <Typography variant="subtitle2" color="text.primary">
          {t(translationPath + "signature_position_landscape")}
        </Typography>
      </Grid>

      <Grid item xs={12} md={6}>
        <FormInput
          size="small"
          name={getName("signatureHorizontalX")}
          label={t(translationPath + "signature_horizontal_x")}
          type="number"
          fullWidth
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <FormInput
          size="small"
          name={getName("signatureHorizontalY")}
          label={t(translationPath + "signature_horizontal_y")}
          type="number"
          fullWidth
        />
      </Grid>

      <Grid item xs={12} sx={{ mt: 1 }}>
        <Divider sx={{ mb: 1.5 }} />
        <Typography variant="subtitle2" color="text.primary">
          {t(translationPath + "signature_position_portrait")}
        </Typography>
      </Grid>

      <Grid item xs={12} md={6}>
        <FormInput
          size="small"
          name={getName("signatureVerticalX")}
          label={t(translationPath + "signature_vertical_x")}
          type="number"
          fullWidth
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <FormInput
          size="small"
          name={getName("signatureVerticalY")}
          label={t(translationPath + "signature_vertical_y")}
          type="number"
          fullWidth
        />
      </Grid>
    </>
  );
});
